import React, { useEffect, useState } from "react";
import AboutThree from "../../../components/homes/about/AboutThree";
import HeaderFour from "../../../components/homes/headers/HeaderFour";
import HeaderThree from "../../../components/homes/headers/HeaderThree";
import PersonalInfoThree from "../../../components/homes/personalInfo/PersonalInfoThree";
import PortfolioThree from "../.././../components/homes/portfolio/PortfolioThree";
import ContactThree from "../../../components/homes/contact/ContactThree";
import { isMaderasPath, URLAPI } from "../../../Helpers/apimaderas";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
export const metadata = {
  title: "Resume-3 || Bostami - Professional portfolio NextJS Template",
  description:
    "Discover Botami,the most impressive portfolio template for work showcase, blog",
};
export default function Page() {
  const { t } = useTranslation();
  const { token: tokenAsesor } = useParams();
  const { pathname } = useLocation();
  const isLivingMaderas = isMaderasPath(pathname);

  const [tab, setTab] = useState("sobremi");
  const [profile, setProfile] = useState({});
  const [profileStatus, setProfileStatus] = useState("loading");
  const [config, setConfig] = useState({});

  const menuItems = [
    { id: 1, icon: "fa-light fa-user", text: t("app.sobreMi"), tab: "sobremi" },
    {
      id: 3,
      icon: "fa-light fa-briefcase",
      text: t("app.desarrollos"),
      tab: "desarrollos",
    },
    {
      id: 5,
      icon: "size-22 fa-light fa-address-book",
      text: t("app.contacto"),
      tab: "contacto",
    },
  ];

  const renderTab = (tab) => {
    const component = {
      sobremi: <AboutThree profile={profile?.data} />,
      desarrollos: <PortfolioThree desarrollos={profile?.data} />,
      contacto: (
        <ContactThree
          tokenAsesor={tokenAsesor}
          pathname={pathname}
          kiuflowContactChannel={config?.kiuflowContactChannel}
          kiuflowAgentId={profile?.data?.vendedor?.kiuflowId}
        />
      ),
    };

    return component[tab];
  };

  const fetchGetConfig = async () => {
    try {
      const resp = await fetch(`${URLAPI(pathname)}/config/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }).then((resp) => resp.json());
      if (resp.success) {
        setConfig(resp.data);
      } else {
        throw new Error(resp.message);
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const fetchProfile = async () => {
    setProfileStatus("loading");

    try {
      const resp = await fetch(`${URLAPI(pathname)}/seller/profile`, {
        method: "POST",
        headers: {
          // Authorization: 'Basic WkpRUEtaSE5HVTpab0piWUlYdkRjd3FjZW5QWWhTQ2RUS3dqcGdYcmRwdQ==',
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: tokenAsesor,
        }),
      }).then((resp) => resp.json());
      if (resp.success) {
        setProfile(resp);
        setProfileStatus("success");
      } else {
        throw new Error(resp.message);
      }
    } catch (error) {
      setProfileStatus("error");
      toast.error(error.message || t("app.errorCargarTarjeta"), {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {

    fetchGetConfig();

    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("maderas-theme") || "dark";
  });

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("maderas-theme", newTheme);
  };

  const isProfileLoading = profileStatus === "loading";

  return (
    <div
      className={`page-wrapper home-3 maderas-elegant ${theme === "light" ? "light-theme" : ""}`}
      aria-busy={isProfileLoading}
    >
      <div className="living-background-overlay" aria-hidden="true"></div>

      <div className="container living-dashboard">
        <HeaderFour
          logo={config?.logo}
          isLivingMaderas={isLivingMaderas}
          theme={theme}
          toggleTheme={toggleTheme}
        />

        {profile?.success ? (
          <>
            <HeaderThree
              menuItemsThree={menuItems}
              tab={tab}
              setTab={setTab}
            />
            <PersonalInfoThree profileInfo={profile} />
            <main className="living-content-column" aria-live="polite">
              <div className="elegant-curve-bg" aria-hidden="true"></div>
              {renderTab(tab)}
              <div className="elegant-curve-bg-2" aria-hidden="true"></div>
            </main>
          </>
        ) : profileStatus === "error" ? (
          <section className="living-request-error" role="alert">
            <span className="living-request-error__icon" aria-hidden="true">
              <i className="fa-regular fa-triangle-exclamation"></i>
            </span>
            <h1>{t("app.errorCargarTarjeta")}</h1>
            <p>{t("app.errorCargarTarjetaDetalle")}</p>
            <button
              type="button"
              className="living-retry-button"
              onClick={fetchProfile}
            >
              <i className="fa-regular fa-arrow-rotate-right" aria-hidden="true"></i>
              {t("app.reintentar")}
            </button>
          </section>
        ) : (
          <>
            <div
              className="living-navigation living-loading-navigation"
              aria-hidden="true"
            >
              <div className="living-loading-navigation__inner">
                {["about", "developments", "contact"].map((item) => (
                  <span className="living-skeleton" key={item}></span>
                ))}
              </div>
            </div>

            <aside className="living-profile-column" aria-hidden="true">
              <div className="bostami-parsonal-info-area living-loading-profile">
                <div className="living-skeleton living-loading-photo"></div>
                <div className="living-skeleton living-loading-name"></div>
                <div className="living-skeleton living-loading-badge"></div>
                <div className="living-loading-socials">
                  {["facebook", "instagram", "linkedin"].map((item) => (
                    <span className="living-skeleton" key={item}></span>
                  ))}
                </div>
                <div className="living-skeleton living-loading-heading"></div>
                <div className="living-loading-contacts">
                  {["phone", "email", "location"].map((item) => (
                    <div className="living-loading-contact" key={item}>
                      <span className="living-skeleton living-loading-contact__icon"></span>
                      <span className="living-loading-contact__text">
                        <span className="living-skeleton"></span>
                        <span className="living-skeleton"></span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </aside>

            <main className="living-content-column living-loading-content">
              <div className="living-loading-content__card">
                <div className="living-loading-copy" aria-hidden="true">
                  <div className="living-skeleton living-loading-title"></div>
                  <div className="living-skeleton living-loading-rule"></div>
                  {["full-1", "full-2", "short-1", "full-3", "medium"].map(
                    (item) => (
                      <div
                        className={`living-skeleton living-loading-line living-loading-line--${item}`}
                        key={item}
                      ></div>
                    ),
                  )}
                </div>

                <div
                  className="living-loading-message"
                  role="status"
                  aria-live="polite"
                >
                  <span className="living-loading-spinner" aria-hidden="true"></span>
                  <span>
                    <strong>{t("app.cargandoTarjeta")}</strong>
                    <small>{t("app.cargandoTarjetaDetalle")}</small>
                  </span>
                </div>
              </div>
            </main>
          </>
        )}
      </div>
    </div>
  );
}
